import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ObjectIcon from '../shared/ObjectIcon';
import { useSelector } from 'react-redux';
import './CustomFormFields.scss';
import { Combobox, Icon, comboboxFilterAndLimit, IconSettings } from '@salesforce/design-system-react';

const lookupItem = (lookupOptions) => (
  <div className='lookup-menu-option'>
    {lookupOptions.option?.icon}
    <span className="slds-listbox__option-text slds-listbox__option-text_entity lookup-menu-option-label">
      {lookupOptions.option.label || ''}
    </span>
  </div>
);
lookupItem.displayName = 'CustomMenuItem';

export const LookupField = ({ enabled, required, label, fieldName, handleChange, lookupOptions, error, defaultValue, disableIcon, lookup }) => {
  const objectIcons = useSelector((state) => state.mail.icons);
  const validateIconExists = () => {
    if (lookup?.length === 1 && objectIcons?.hasOwnProperty(lookup[0])) {
      return true;
    }

    return false;
  };

  const formattedOptions = lookupOptions.map((lookupOption) => ({
    ...lookupOption,
    label: lookupOption.Name,
    value: lookupOption.Id,
    icon: (!disableIcon && validateIconExists()) ? (<ObjectIcon objectApiName={lookup[0]} className='lookup-option'/>) : null,
  }));
  const [state, setState] = useState({
    inputValue: '',
    selection: [],
  });


  useEffect(() => {
    if (defaultValue) {
      const defaultOption = formattedOptions.find((option) => option?.value === defaultValue || option?.Name === defaultValue);
      setState({
        inputValue: '',
        selection: [
          {
            label: defaultOption?.Name,
            value: defaultOption?.Id,
            icon: (!disableIcon && validateIconExists()) ? (<ObjectIcon objectApiName={lookup[0]} className='lookup-option'/>) : null,
          },
        ],
      });
    }
  }, [defaultValue]);

  return (
    <IconSettings iconPath="/assets">
      <Combobox
        classNameContainer={error === '' ? '' : 'lookup-error'}
        id="combobox-inline-single"
        disabled={!enabled}
        required={required}
        name={fieldName}
        errorText={error}
        defaultValue={defaultValue ? state.selection : []}
        events={{
          onChange: (event, { value }) => {
            setState({ ...state, inputValue: value });
          },
          onRequestRemoveSelectedOption: (event, data) => {
            setState({
              inputValue: '',
              selection: data.selection,
            });
            handleChange(event, { fieldName, value: '' });
          },
          onSubmit: (event, { value }) => {
            setState({
              inputValue: '',
              selection: [
                {
                  label: value,
                  icon: !disableIcon ? (<Icon name='taskcode' category='utility' />) : null,
                },
              ],
            });
          },
          onSelect: (event, data) => {
            setState({
              inputValue: '',
              selection: data.selection,
            });
            handleChange(event, { fieldName, value: data.selection[0].value });
          },
          onBlur: () => {
            if (state.selection.length === 0) {
              setState({ ...state, inputValue: '' });
            }
          },
        }}
        labels={{
          label,
          placeholder: `Search ${label}`,
        }}
        onRenderMenuItem={(lookupOptions) => lookupItem(lookupOptions)}
        options={comboboxFilterAndLimit({
          inputValue: state.inputValue,
          options: formattedOptions,
          selection: state.selection,
          limit: lookupOptions.length,
        })}
        menuItemVisibleLength={7}
        selection={state.selection}
        value={
            state.selection ?
            state.selection.label :
            state.inputValue
        }
        variant='inline-listbox'
      />
    </IconSettings>
  );
};

LookupField.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  lookupOptions: PropTypes.array,
  error: PropTypes.string,
  defaultValue: PropTypes.string,
  disableIcon: PropTypes.bool,
  lookup: PropTypes.array,
};
